<template>
    <b-modal
        id="spontaneous-evaluation-modal"
        size="lg"
        centered
        hide-header
        hide-footer
        :busy="isSubmitting"
        :no-close-on-esc="isSubmitting"
        :no-close-on-backdrop="isSubmitting"
        @hidden="$router.back(-1)"
    >
        <h3>{{ $t('values.sendSpontaneousEvaluation') }}</h3>
        <evaluation
            class="mb-2"
            :valueId="valueId"
            :evaluated="evaluated"
            :isSubmitting="isSubmitting"
            :questionnaireId="questionnaireId"
            @submit="onSubmit"
            @hide="$bvModal.hide('spontaneous-evaluation-modal')"
            @change-questionnaire="evaluatedQuestionnaireId = $event"
        />
    </b-modal>
</template>
<script>
import i18n from '@/i18n'
import { EventBuzz } from '@/main'
import { success } from '@/lib/notification'
import Modal from '@/views/components/modal'
import Loader from '@/views/components/loader'
import Evaluation from './components/Evaluation'
import { sendSpontaneousEvaluation } from '@/views/values/api'

export default {
    props: {
        evaluated: {
            type: Object,
            default: () => null,
        },
    },
    components: {
        Modal,
        Loader,
        Evaluation,
    },
    beforeMount() {
        const keys = ['valueId', 'questionnaireId']
        Object.keys(this.$route.query).forEach(key => {
            if (keys.includes(key)) {
                this[key] = parseInt(this.$route.query[key])
            }
        })
        this.evaluatedQuestionnaireId = this.questionnaireId
    },
    mounted() {
        this.$bvModal.show('spontaneous-evaluation-modal')
    },
    data() {
        return {
            valueId: null,
            isSubmitting: false,
            questionnaireId: null,
            evaluatedQuestionnaireId: null,
        }
    },
    methods: {
        onSubmit(data) {
            this.isSubmitting = true
            sendSpontaneousEvaluation(data).finally(async () => {
                this.isSubmitting = false
                this.$bvModal.hide('spontaneous-evaluation-modal')

                await this.$nextTick()

                EventBuzz.$emit(
                    'spontaneous-evaluation-sented',
                    this.evaluatedQuestionnaireId
                )
                this.$emit('spontaneous-evaluation-sented')
                success(i18n.t('notification.evaluationSentSuccessfully'))
            })
        },
    },
}
</script>
